import React from 'react'
import SecondHeader from '../../../components/SecondHeader/SecondHeader'
import Footer from '../../../components/Footer/Footer'
import SampleDashboardBar from '../../../components/sampleComponents/sampleDashboardTopBar/SampleDashboardBar'

const SampleDashboardLayout = ({ children }) => {
    return (
        <>
            <SecondHeader />
            <div className="dashboard-box">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <SampleDashboardBar />
                        </div>

                        <div className="col-md-12 sample-pages-box">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default SampleDashboardLayout